'use strict'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { Route, Router, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './app/store'
import history from './app/history'
import SideBarNavigation from './sidebar/SideBarNavigation'
import { TidewaysContext } from './app/context'
import AppRouter from './router'
;(function(jQuery) {
    jQuery.fn.sidebarNavigation = function(options) {
        jQuery.extend({}, jQuery.fn.sidebarNavigation.defaults, options)

        return jQuery(this).each(function() {
            let container = jQuery(this)[0]
            const root = createRoot(container)
            let appData = jQuery(container).data('sidebarnavigation')

            if (appData && appData.tidewaysContext && appData.routes && appData.user) {
                let tidewaysContext = new TidewaysContext(appData.tidewaysContext)
                let router = new AppRouter(history, appData.routes, tidewaysContext, appData.user)

                store.dispatch({ type: 'TIDEWAYS_INIT', tidewaysContext: tidewaysContext, router: router })

                const route = router.match(history.location.pathname)
                store.dispatch({ type: 'TIDEWAYS_ROUTE', route: route })
            } else {
                // the app.jquery.js sets this, when the main app is loaded.  When
                // its not, then we are most likely outside application and can
                // show default.
                //
                // This is not true for application settings, for example, but they
                // have their own menu.
                let router = store.getState().tidewaysContext.router
                if (!router) {
                    return <div />
                }
            }

            root.render(
                <Provider store={store}>
                    <Router history={history}>
                        <Switch>
                            <Route component={SideBarNavigation} />
                        </Switch>
                    </Router>
                </Provider>,
            )
        })
    }

    jQuery.fn.sidebarNavigation.defaults = {}
})(jQuery)

window.pluginRegistry.register({ selector: '[data-sidebarnavigation]', invoke: 'sidebarNavigation', isReact: true })
